import React, { useState } from 'react'
import { Form, useFormikContext } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import CountryInput from '../country-input'
import StateInput from '../state-input'
import { FormattedMessage, useIntl } from 'react-intl'
import { BigButton } from '../../../../components/button'
import Input from '../normal-input'
import PhoneInput from '../normal-input/phone'
import AutoAddress from '../address-generator'
import EmailInput from '../email-input'
import { useLogin } from '../../../../hooks/common'
import { useEffect } from 'react'
import PrivacyPart from '../privacy-part'
import {getAddress} from "../../../../../api";
import {SensorsTrack} from "../../../../utils/sensor";

export default props => {
    useStyles(classes)
    const { countries, disableCountry, shouldExpand, areaCode, setAreaCode, instantValidate, privacyPic, privacyInfo } = props
    const { values,setFieldValue, isSubmitting, submitCount } = useFormikContext()
    const intl = useIntl()
    const [full, setFull] = useState(shouldExpand)
    const isLogin = useLogin()
    const [lastBlurField, setLastBlurField] = useState(null);
    const [fillAddress, setFillAddress] = useState(true);

    useEffect(() => {
        if(submitCount >= 1){
            setFull(true)
        }
    }, [submitCount])
    useEffect(() => {
        const { country,email, firstName, lastName, phoneNumber } = values;
        console.log("@fetchAndFillAddress2")
        if (
            fillAddress&&lastBlurField &&country=='US'&&
            email
        ) {
            setLastBlurField(null); // 只触发一次
            fetchAndFillAddress();
        }
    }, [values.email,values.firstName,values.lastName,values.phoneNumber,lastBlurField]);
    const fetchAndFillAddress = async () => {
        setTimeout(async () => {
            console.log("@fetchAndFillAddress")
            const { country,email, firstName, lastName, phoneNumber } = values;
            if(country=='US'&&email){
                const search={email,...(firstName&&{firstName}),...(lastName&&{lastName}),...(phoneNumber&&{phoneNumber})}
                console.log("@search",search)
                const response=await getAddress(search);
                console.log(response)
                if(response&&response.code==200&&response.success&&response.result){
                    const addressResult=response.result
                    addressResult.firstName&&setFieldValue('firstName', addressResult.firstName);
                    addressResult.lastName&&setFieldValue('lastName', addressResult.lastName);
                    addressResult.phoneNumber&&setFieldValue('phoneNumber', addressResult.phoneNumber);
                    addressResult.streetAddress1&&setFieldValue('streetAddress1', addressResult.streetAddress1);
                    addressResult.unit&&setFieldValue('unit', addressResult.unit);
                    if(addressResult.state&&addressResult.state.value){
                        setFieldValue('state', addressResult.state.value);
                    }
                    addressResult.city&&setFieldValue('city', addressResult.city);
                    addressResult.zipCode&&setFieldValue('zipCode', addressResult.zipCode);
                    setFillAddress(false)
                    SensorsTrack('COMPLETION_ADDRESS', { email: email })
                }

            }
        },0)
    };

    return <Form className={classes.Form}>
        <div className={classes.Boxes}>
            <div className={classes.Box}>
                <CountryInput
                    name="country"
                    onlyCountry
                    label={"*"+intl.formatMessage({ id: 'country', defaultMessage: 'Country / Region' })}
                    countries={countries} disableCountry={disableCountry}/>
            </div>

            {
                !isLogin && <div className={classes.Box}>
                <EmailInput
                    name="email"
                    label={"*"+intl.formatMessage({ id: 'email', defaultMessage: 'Email' })}
                    onBlur={() => setLastBlurField('email')}
                    selectHandle={() => setLastBlurField('email')}
                />
            </div>
            }

            

            <div className={classes.Box}>
                <Input
                    name="firstName"
                    label={"*"+intl.formatMessage({ id: 'first_name', defaultMessage: 'First Name' })}
                    onBlur={() => setLastBlurField('firstName')}
                />

                <Input
                    name="lastName"
                    label={"*"+intl.formatMessage({ id: 'last_name', defaultMessage: 'Last Name' })}
                    onBlur={() => setLastBlurField('lastName')}
                />

                <PhoneInput
                    name="phoneNumber"
                    label={"*"+intl.formatMessage({ id: 'phone_number', defaultMessage: 'Phone Number' })} 
                    areaCode={areaCode} 
                    setAreaCode={setAreaCode}
                    instantValidate={instantValidate}
                    onBlur={() => setLastBlurField('phoneNumber')}
                />
            </div>

            <div className={classes.Box}>
                <div>
                    <AutoAddress onMaually={setFull} />
                    {
                        !full && !values.streetAddress1 && <div className={classes.EnterManually} onClick={e => setFull(true)}>
                            <span style={{ color: 'rgb(62, 116, 174)' }}>
                                <FormattedMessage id="enter_it_manually" defaultMessage="Enter it manually" />
                            </span>
                        </div>
                    }

                </div>

                {
                    (full || values.streetAddress1) && <>
                        <Input
                            name="streetAddress1"
                            label={"*"+intl.formatMessage({ id: 'address_line_1', defaultMessage: 'Address Line 1' })}
                            placeholder={intl.formatMessage({ id: 'address_line_1_placeholder', defaultMessage: 'Street name and street number, company name.' })}
                        />
                        <Input
                            name="unit"
                            label={intl.formatMessage({ id: 'address_line_2', defaultMessage: 'Address Line 2' })}
                            placeholder={intl.formatMessage({ id: 'optional', defaultMessage: 'Optional' })}
                        />
                        <StateInput
                            name="state"
                            label={"*"+intl.formatMessage({ id: 'state', defaultMessage: 'State / Provience' })}
                            countries={countries} /> 

                        <Input
                            name="city"
                            label={"*"+intl.formatMessage({ id: 'city', defaultMessage: 'City' })}
                        />
                        <Input
                            name="zipCode"
                            instantValidate={instantValidate}
                            label={"*"+intl.formatMessage({ id: 'zip_code', defaultMessage: 'Zip Code / Postal Code' })}
                        />
                    </>
                }


            </div>

        </div>
        {!fillAddress&&<div className={classes.FilledAddressRemind}>Review your auto-filled address before saving.</div>}
        <div className={classes.Button}>
            <BigButton type="submit" loading={isSubmitting}><FormattedMessage id="save" defaultMessage={'Save'} /></BigButton>
        </div>

        <PrivacyPart privacyPic={privacyPic} privacyInfo={privacyInfo}/>
    </Form>
}